import { Dispatch } from 'react';
import { post } from 'communication/httpClient';
import { SYNC_FAILED, SYNC_FINISHED, SYNC_INITIATED, SET_DEVICES } from './actionTypes';
import { IDeviceAction, IDevicesActions } from './types';

export const getActions = (dispatch: Dispatch<IDeviceAction>): IDevicesActions => ({
  loadDevices: async (params) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await post('/api/devices/find', { params });

    if (data) {
      dispatch({
        type: SET_DEVICES,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
});
